/**
 * External dependencies
 */
import cx from 'classnames';
import { usePage } from '@inertiajs/react';

/**
 * Internal dependencies
 */
import OnboardingFlow from '@/assets/images/inhouse-application.jpg';
import Logo from '@/assets/images/inhouse_logo_text.png';
import ResponsiveImage from '@/common/components/responsive-image/responsive-image';

const Guest = ({
    children,
    size,
    showBackButton,
    redirectLocation,
    image,
    CustomMediaComponent,
    className,
    responsiveImage = false,
}) => {
    const { externalLinks } = usePage().props;

    return (
        <main className="main">
            <div
                className={cx('guest', className, {
                    'guest--large': size === 'large',
                })}
            >
                <div className="guest__inner">
                    {showBackButton && redirectLocation ? (
                        <button
                            type="button"
                            className="guest__back-btn"
                            onClick={() => (window.location.href = decodeURIComponent(redirectLocation))}
                        >
                            <span />
                            Back
                        </button>
                    ) : null}

                    <div className="guest__media">
                        {image ? (
                            <div className="guest__media-custom">
                                {responsiveImage ? (
                                    <ResponsiveImage src={image} alt="Guest" />
                                ) : (
                                    <img src={image} alt="Guest" />
                                )}
                            </div>
                        ) : (
                            <img src={OnboardingFlow} alt="Guest" />
                        )}

                        <div className={'guest__media__image_text'}>
                            <a href={externalLinks?.inhouse?.main}>
                                <img src={Logo} alt="" />
                            </a>
                        </div>

                        {CustomMediaComponent && <CustomMediaComponent />}
                    </div>

                    <div className="guest__content">{children}</div>
                </div>
            </div>
        </main>
    );
};

export default Guest;
